<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectFinanceOption" });
import { SelectSingle } from "../../../../selects/index.js";
import { FINANCE_OPTIONS } from "../../config/finance-options.js";
import { t } from "svelte-i18n";
export let key;
export let label = "resource.finance.label";
export let placeholder = "resource.finance.placeholder";
export let isDisabled = false;
export let isRequired = false;
$: options = FINANCE_OPTIONS.map((option) => ({ ...option, label: $t(option.label) }));
</script>

<SelectSingle
    bind:key = { key }
    name = 'finance.option'
    { placeholder }
    { options }
    { label }
    { isDisabled }
    { isRequired }
/>